import { render, staticRenderFns } from "./AvisoConfGeneralModal.vue?vue&type=template&id=02746565"
import script from "./AvisoConfGeneralModal.vue?vue&type=script&lang=js"
export * from "./AvisoConfGeneralModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports